// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"cF","footer":"cG","subscriptionsList":"cH","disclaimer":"cI"};